import React from "react"
import FAQItem from "../components/questions/Questions"
import styles from "./ForthScreen.module.css"
import Button from "../components/button/Button"

const ForthScreen = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>שאלות נפוצות</div>
        </div>

        <FAQItem
          question="למי השירות מתאים?"
          answer="השירות שלי מתאים למגוון רחב של לקוחות הנמצאים בשלבים שונים בחייהם: מי שבונה בית חדש - ליווי מלא משלב תכנון הקונספט ועד הכניסה לבית. מי שרכש דירה חדשה - עיצוב והתאמה אישית של הדירה לצרכים הייחודיים שלכם, כולל התאמות ושדרוגים. מי שמעוניין לשפץ בית קיים - תכנון ועיצוב מחדש של הבית כשבסופו תהנו מחלל מעוצב, איכותי ומותאם בדיוק לכם. מי ששוכר דירה - פתרונות עיצוב גמישים ולא קבועים וכן, טיפים לארגון יעיל ופתרונות אחסון חכמים."
        />

        <FAQItem
          question="מה המחיר לעיצוב פנים של דירה?"
          answer="המחיר תלוי בגודל הדירה, ברמת המורכבות של העיצוב והשירותים שיבוצעו. לאחר הפגישה הראשונית, אוכל להגיש הצעת מחיר מותאמת אישית שמתאימה לצרכים שלכם ולתקציב העומד לרשותכם. מומלץ להגיע לפגישה הראשונה עם רשימת צרכים והבנה מה התקציב שיש לכם."
        />

        <FAQItem
          question="על מה נדבר במהלך הפגישה הראשונה?"
          answer="מה מפריע לכם בבית? מה תרצו לשנות? כמה נפשות יתגוררו בבית? ומה גילם? מה חסר לכם בבית הנוכחי? מה החלום שלכם? כמה תרצו להשקיע? מה הסגנון שלכם? האם יש לכם העדפות ספציפיות? איזה סוג פגישה אתם צריכים? ועוד..."
        />

        <FAQItem
          question="מה קורה אם יש לנו תקציב מוגבל?"
          answer="אני מתאימה את הפתרונות העיצוביים גם לתקציבים מוגבלים, ומוצאת פתרונות יצירתיים להשגת תוצאה מרשימה במסגרת התקציב שלכם."
        />

        <FAQItem
          question="מה קורה אם נרצה להמשיך אחרי הפגישה?"
          answer="אם תחליטו להתקדם, אעמוד לרשותכם להמשך תהליך עיצוב מלא/חלקי, בהתאם לצורך שלכם."
        />

        <FAQItem
          question="האם שני בני הזוג צריכים להיות בפגישה?"
          answer="מומלץ ששני בני הזוג ישתתפו כדי לוודא שכל הצרכים והרצונות מיוצגים בתהליך."
        />

        <FAQItem
          question="מה אם אנחנו לא בטוחים בסגנון העיצוב שנרצה?"
          answer="אני כאן כדי לעזור לכם לגלות מה מתאים לכם. במהלך הפגישה, אציג דוגמאות ורעיונות שיעזרו לכם לגבש את הסגנון האידיאלי עבורכם."
        />

        <FAQItem
          question="איך עליי/נו להתכונן לפגישה הראשונה איתך?"
          answer="לפני פגישת ייעוץ לעיצוב תקבלו שאלון מסודר למילוי, ונערוך שיחה ובה נברר היטב מה הצרכים שלכם מה עליי להביא ולהכין עבורכם. שאלון תוכלו להעביר אליי תמונות, תוכניות, ולדייק את תוכן הפגישה, כדי שתהיה הכי יעילה ומועילה בשבילכם."
        />

        <FAQItem
          question="האם פגישת ייעוץ מתאימה גם לדירות שכורות?"
          answer="בהחלט! פגישת הייעוץ מתאימה גם לדירות שכורות, ומטרתה למצוא פתרונות יצירתיים ללא שינויים קבועים."
        />

        <FAQItem
          question="מה מבחינת בעלי המקצוע?"
          answer="זה לגמרי לשיקולכם, אפשר לעבוד עם בעלי מקצוע מטעמכם או עם בעלי מקצוע מומלצים שאני מכירה."
        />

        <FAQItem
          question="איך את מוודאת שהפרויקט יישאר במסגרת התקציב שנקבע?"
          answer="בתחילת הפרויקט אנו מגדירים יחד תקציב ברור ועמידה בו היא חלק מהתהליך. כל הוצאה מקבלת את האישור שלכם מראש, ואנחנו מבצעים מעקב צמוד אחר ההוצאות כדי לוודא שאין חריגות. כל שלב מתוכנן לפרטי פרטים בטבלת אקסל משותפת איתכם לשקיפות מלאה ובכדי למנוע הוצאות בלתי צפויות."
        />

        <FAQItem
          question="האם הפגישה יכולה להתקיים בזום?"
          answer="אם ברצונכם בשירות מסלול ליווי מלא, הפגישה תתקיים בנכס הקיים או העתידי, אגיע אליכם עם מזוודת חומרים דוגמאות מטריפה להתרשמותכם. בשאר מסלולי העיצוב ניתן בהחלט לקיים את הפגישה בזום."
        />

        <FAQItem
          question="האם התהליך כולל הדמיות תלת מימד ריאליסטיות?"
          answer="מסלול ליווי מלא כולל הדמיות תלת ממד, בשאר מסלולי העיצוב השירות ניתן בתשלום."
        />

        <FAQItem
          question="כמה זמן לאחר פגישת הייעוץ הממוקדת אקבל את המסמך המסודר?"
          answer="המסמך המסודר יישלח אליכם תוך 5 ימי עסקים, ויכלול רשימות רכישה, הנחיות וספקים מומלצים."
        />

        <FAQItem
          question="האם פגישת ייעוץ כוללת שינוי מבני של החלל?"
          answer="פגישת הייעוץ נועדה למקסם את המצב הקיים ואינה כוללת תכניות לשינוי מבני של החלל, כגון הזזת קירות או שיפוץ תשתיות."
        />
      </div>
      <Button text="טלי יש לי עוד כמה שאלות" />
    </div>
  )
}

export default ForthScreen